/**
 * Format source type enum to readable text
 */
export const formatSourceType = (sourceType) => {
  if (!sourceType) return "Unknown";
  return sourceType
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

/**
 * Get color for source type badge
 */
export const getSourceTypeColor = (sourceType) => {
  const colors = {
    event: "var(--color-primary)",
    communication_message: "var(--color-secondary)",
    birthday: "#ff9500",
    eminute: "#8543f1",
    other: "#525252",
  };
  return colors[sourceType] || colors.other;
};

/**
 * Mask phone numbers for privacy (e.g., 234***5678)
 */
export const maskPhoneNumber = (phone) => {
  if (!phone) return "N/A";
  if (phone.length <= 7) return phone;
  const start = phone.substring(0, 3);
  const end = phone.substring(phone.length - 4);
  return `${start}***${end}`;
};

/**
 * Format SMS count display
 */
export const formatSmsCount = (count) => {
  return count || 1;
};

/**
 * Get status badge color
 */
export const getStatusBadgeColor = (status) => {
  const colors = {
    sent: "#19BC31",
    failed: "#FF4343",
    pending: "#FFA500",
    delivered: "var(--color-secondary)",
  };
  return colors[status?.toLowerCase()] || "#A1A0A0";
};

/**
 * Get status badge text
 */
export const getStatusBadgeText = (status) => {
  if (!status) return "Unknown";
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
